module.exports = __webpack_public_path__ + "7bcdc15bf5145c30cb62a1df57bb6492.pdf";